import React, { Fragment, useState, useEffect, useCallback, useContext } from 'react';
import { MENUITEMS } from '../../Sidebar/Menu';
import { Search } from 'react-feather';
import { Col, Input } from 'reactstrap';
import CustomizerContext from '../../../_helper/Customizer';
import ListOfMenu from '../RightBar/Bookmark/ListOfMenu';
import EmpltyClass from '../RightBar/Bookmark/EmptyClass';
import { headerSearch } from '../../../CommonURL';
import { getMasterDataToken } from '../../../Utils/restUtils';

const Searchbar = () => {
    const mainmenu = MENUITEMS;
    const [searchValue, setSearchValue] = useState('');
    const [searchIcon, setSearchIcon] = useState(false);
    const [searchToggle, setSearchToggle] = useState(false);
    const [searchResult, setSearchResult] = useState([]);
    const { setIsClose } = useContext(CustomizerContext);
    const [IsOpen, setIsOpen] = useState(false);

    const escFunction = useCallback((event) => {
        if (event.keyCode === 27) {
            setSearchValue('');
            setSearchResult([]);
            setIsClose(false);
        }
    }, []);
    useEffect(() => {
        document.addEventListener('keydown', escFunction, false);
        return () => {
            document.removeEventListener('keydown', escFunction, false);
        };
    }, [escFunction, searchValue]);

    const checkSearchResultEmpty = (items) => {
        if (!items.length) {
            setSearchIcon(true);
        } else {
            setSearchIcon(false);
        }
    };
    const addFix = () => {
        setSearchToggle(true);
    };
    const removeFix = useCallback(() => {
        setSearchValue('');
        setSearchToggle(false);
        setIsClose(false);
    }, []);
    useEffect(() => {
        if (!IsOpen) {
            setSearchValue('');
            setSearchToggle(false);
            setIsClose(false);
        }
    }, [IsOpen])
    const handleSearchKeyword = async (keyword) => {
  setSearchValue(keyword);

  if (!keyword.trim()) {
    removeFix();
    setSearchResult([]);
    return;
  }

  addFix();

  const response = await getMasterDataToken(
    `${headerSearch}?search_value=${keyword}`
  );

console.log("user",response?.data?.data?.[0]?.user_id);
  if (response?.data?.status === true) {
    
const result = (response.data.data || []).map((item, index) => {
  return {
    id: index + 1,

    title:
      item.type === "user"
        ? item.name
        :  `${item.company_name} - ${item.user_name} (${item.name})`,

    path:
      item.type === "user"
        ? `${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${item.id}`
        : `${process.env.PUBLIC_URL}/subscriptions/companyProfile?id=${item.company_id}&user_id=${item.user_id}&industryId=${item.industry_type_id}`,

    icon: "bookmark",
    type: "link",

    state:
      item.type === "company"
        ? {
            clientUrl: item.client_url,
            industryName: item.name,
          }
        : {},
  };
});

  setSearchResult(result);
  setSearchIcon(result.length === 0);
}else {
    setSearchResult([]);
    setSearchIcon(true);
  }
};

    return (
        <Fragment>
            <Col className="left-header horizontal-wrapper ps-0">
                <div className={`input-group search-form ${IsOpen ? 'open' : ''}`}>
                    <Input type="text" placeholder="Search Here.."
                    value={searchValue}
                    onChange={(e) => { handleSearchKeyword(e.target.value) }} />
                    <span className="input-group-text mobile-search" >
                        <Search onClick={() => { setIsOpen(!IsOpen); }} />
                    </span>
                    <ListOfMenu searchValue={searchValue} searchResult={searchResult} removeFix={removeFix} searchBar={true} searchToggle={searchToggle} />
                    <EmpltyClass searchIcon={searchIcon} search={true} />
                </div>
            </Col>
        </Fragment >
    );
};
export default Searchbar;